export default "__VITE_ASSET__DMu4eMxS__"